import React, { FC, ReactElement, ReactNode } from 'react'
import { Tooltip as ReactTooltip, type PlacesType } from 'react-tooltip'

import { GUID } from '@hoxtonmix/utils'

type TooltipProps = {
  content: ReactElement | string | undefined
  place?: PlacesType
  showIcon?: boolean
  children?: ReactNode
}

const Tooltip: FC<TooltipProps> = ({ children, content, place, showIcon }) => {
  const id = GUID()

  if (!content) {
    return <>{children}</>
  }

  const icon =
    showIcon && children ? (
      <span className='ms-1 fa fa-info-circle' data-tooltip-id={id} />
    ) : null

  return (
    <>
      {children && (
        <span data-tooltip-id={id}>
          {children}
          {icon}
        </span>
      )}
      {!children && <span className='fa fa-info-circle' data-tooltip-id={id} />}
      <ReactTooltip id={id} place={place || 'top'}>
        {content}
      </ReactTooltip>
    </>
  )
}

export default Tooltip
